import { Injectable } from '@angular/core';
import { ApiBase } from './api.base';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MunicipiosApi extends ApiBase {

    constructor(http: HttpClient) {
        super(http, 'municipios');
    }

}
